import script from "./TaxDeductionRequestsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxDeductionRequestsPage.vue?vue&type=script&setup=true&lang=js"

import "./TaxDeductionRequestsPage.vue?vue&type=style&index=0&id=1e95c26a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e95c26a"]])

export default __exports__